import _Radio from "antd/es/radio";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import cs from 'classnames';
import './index.less';

/**
 * import { SLRadio } from '@yy/sl-admin-components'
 */
var SLRadio = function SLRadio(props) {
  return /*#__PURE__*/React.createElement(_Radio, _extends({}, props, {
    className: cs('sl-radio', props.className)
  }));
};

var Group = function Group(props) {
  return /*#__PURE__*/React.createElement(_Radio.Group, _extends({}, props, {
    className: cs('sl-radio-group', props.className)
  }));
};

SLRadio.Group = Group;
SLRadio.Button = _Radio.Button;
export default SLRadio;